import React from 'react';
import { Ripple } from '@isyc-react/animation/modules/base/transition';
import { InputSelect } from '@isyc-react/form/modules/input/select';
import { DropSingleAcceptedView, DropSingleRejectedView, } from '@isyc-react/form-file/modules/drop-file/drop-status/drop-single/views';
import { DropZoneFile } from '@isyc-react/form-file/modules/drop-file/drop-zone';
// FIXME DEPRECATED --- NO BASAR NADA EN ESTE CONTENIDO.
// DROP ZONE, ACCEPTED y REJECTED actualizados para usar los componentes nuevos de la lib.
export const allowedMimeTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/tiff', 'application/pdf'];
const AcceptedFile = props => {
    const { file, open, setAccepted, remove, disabled, uploaded, uploadedArchiveId, uploadedArchiveName } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(DropSingleAcceptedView, { open: open, remove: remove, disabled: disabled, accepted: {
                file: file !== null && file !== void 0 ? file : undefined,
                api: uploaded
                    ? {
                        id: uploadedArchiveId !== null && uploadedArchiveId !== void 0 ? uploadedArchiveId : 0,
                        name: uploadedArchiveName !== null && uploadedArchiveName !== void 0 ? uploadedArchiveName : '',
                    }
                    : undefined,
            } })));
};
const RejectedFile = props => {
    const { rejected, open, remove, disabled } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(DropSingleRejectedView, { open: open, remove: remove, disabled: disabled, rejected: rejected })));
};
const DropFileDefaultView = (props) => (React.createElement(React.Fragment, null,
    React.createElement("div", { className: 'text-center text-md-end' },
        React.createElement("button", { type: 'button', className: 'btn btn-ripple btn-primary', onClick: props.open, disabled: props.disabled, "aria-label": 'Parcourir', "aria-describedby": 'Parcourir', title: 'Parcourir' },
            React.createElement(Ripple, { disabled: props.disabled }),
            "Parcourir"))));
const DropFileStatus = (props) => {
    if (props.state.accepted || props.uploaded) {
        return (React.createElement(AcceptedFile, { file: props.state.accepted, uploaded: props.uploaded, uploadedArchiveId: props.uploadedArchiveId, uploadedArchiveName: props.uploadedArchiveName, open: props.open, setAccepted: props.setAccepted, remove: props.removeAccepted, disabled: props.disabled }));
    }
    else if (props.state.rejected) {
        return (React.createElement(RejectedFile, { rejected: [props.state.rejected], open: props.open, remove: props.removeRejected, disabled: props.disabled }));
    }
    else {
        return React.createElement(DropFileDefaultView, { open: props.open, disabled: props.disabled });
    }
};
export const DeprecatedDropFile = props => {
    const { minSize = 0, maxSize = Infinity, disabled = false, showDropFileStatus = true, className, onAccepted, onRejected, children, options, initialOptionSelected, disabledSelect, onOptionSelected, afterSelectChildren, uploaded, uploadedArchiveId, uploadedArchiveName, onRemoveAccepted, onRemoveRejected, } = props;
    const [state, setState] = React.useState({
        accepted: null,
        rejected: null,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(DropZoneFile, { className: className, disabled: disabled, minSize: minSize, maxSize: maxSize, multiple: false, accept: allowedMimeTypes, onDropAccepted: acceptedFiles => {
                setState(state => (Object.assign(Object.assign({}, state), { accepted: acceptedFiles[0], rejected: null })));
                onAccepted && onAccepted(acceptedFiles[0]);
            }, onDropRejected: rejectedFiles => {
                setState(state => (Object.assign(Object.assign({}, state), { rejected: rejectedFiles[0], accepted: null })));
                onRejected && onRejected(rejectedFiles[0].file);
            } }, ({ open }) => (React.createElement(React.Fragment, null,
            children,
            options && options.length > 0 && (React.createElement("div", { className: 'mb-4' },
                React.createElement(InputSelect, { defaultValue: initialOptionSelected, isDisabled: disabledSelect, isSearchable: false, placeholder: 'Sélectionner', options: options, noOptionsMessage: ({ inputValue }) => `Aucune option pour ${inputValue}`, onChange: selected => onOptionSelected && onOptionSelected(selected) }))),
            afterSelectChildren,
            showDropFileStatus && (React.createElement(DropFileStatus, { state: state, open: open, disabled: disabled, uploaded: uploaded, uploadedArchiveId: uploadedArchiveId, uploadedArchiveName: uploadedArchiveName, setAccepted: (file) => {
                    setState(state => {
                        let accepted = state.accepted || file;
                        return Object.assign(Object.assign({}, state), { accepted });
                    });
                }, removeAccepted: () => {
                    setState(state => (Object.assign(Object.assign({}, state), { accepted: null })));
                    onRemoveAccepted && onRemoveAccepted();
                }, removeRejected: () => {
                    setState(state => (Object.assign(Object.assign({}, state), { rejected: null })));
                    onRemoveRejected && onRemoveRejected();
                } })))))));
};
